export default __webpack_public_path__ + "static/wmp-31d223f6835f7b8cd06348271248620b.png";